
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/section/[slug]/page/[pageNum]",
      function () {
        return require("private-next-pages/section/[slug]/page/[pageNum].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/section/[slug]/page/[pageNum]"])
      });
    }
  